/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteCustomerIdGoalGoalIdParams,
  GetCustomerArchivedParams,
  GetCustomerIdBodyHistoryParams,
  GetCustomerIdBodyParams,
  GetCustomerIdCalendarParams,
  GetCustomerIdComplianceParams,
  GetCustomerIdConsistencyParams,
  GetCustomerIdExerciseExerciseIdRecordsParams,
  GetCustomerIdExerciseMatrixParams,
  GetCustomerIdGoalParams,
  GetCustomerIdHistoryParams,
  GetCustomerIdLastSessionParams,
  GetCustomerIdMuscleVolumeParams,
  GetCustomerIdPersonalRecordsParams,
  GetCustomerIdProgressSummaryParams,
  GetCustomerIdRecentSessionsParams,
  GetCustomerIdTrainedExercisesParams,
  GetCustomerIdTrainingTrendsParams,
  GetCustomerInvitationsParams,
  GetCustomerMeInvitationsParams,
  GetCustomerParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  PatchCustomerIdGoalGoalIdParams,
  PostCustomerIdGoalGoalIdCompleteParams,
  PostCustomerIdGoalParams,
  TrainWithMeModulesClientsDtosRequestsPatchCustomerRequest,
  TrainWithMeModulesClientsDtosRequestsPatchGoalRequest,
  TrainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest,
  TrainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest,
  TrainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest,
  TrainWithMeModulesClientsDtosRequestsPostGoalRequest,
  TrainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest,
  TrainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest,
  TrainWithMeModulesClientsDtosResponsesArchivedClientPageResponse,
  TrainWithMeModulesClientsDtosResponsesCoachingRequestPageResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerBodyHistoryResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerBodyResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerCalendarResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerComplianceResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerConsistencyResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerDetailResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerExerciseMatrixResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerExerciseRecordsResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerGoalResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerHistoryResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerInvitationResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerLastSessionResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerMuscleVolumeResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerNoteResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerPersonalRecordsResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerProgressSummaryResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerRecentSessionsResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerTrainedExercisesResponse,
  TrainWithMeModulesClientsDtosResponsesCustomerTrainingTrendsResponse,
  TrainWithMeModulesClientsDtosResponsesGetCustomerResponse,
  TrainWithMeModulesClientsDtosResponsesGetTrainerInvitationResponse,
  TrainWithMeModulesClientsDtosResponsesMyInvitationPageResponse,
  TrainWithMeModulesClientsDtosResponsesSeatUsageResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCustomer = (
    params?: GetCustomerParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetCustomerResponse[]>(
      {url: `/customer`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerQueryKey = (params?: GetCustomerParams,) => {
    return [
    `/customer`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = ErrorType<unknown>


export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCustomerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerArchived = (
    params?: GetCustomerArchivedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesArchivedClientPageResponse>(
      {url: `/customer/archived`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerArchivedQueryKey = (params?: GetCustomerArchivedParams,) => {
    return [
    `/customer/archived`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerArchivedQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerArchived>>, TError = ErrorType<unknown>>(params?: GetCustomerArchivedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerArchived>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerArchivedQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerArchived>>> = ({ signal }) => getCustomerArchived(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerArchived>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerArchivedQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerArchived>>>
export type GetCustomerArchivedQueryError = ErrorType<unknown>


export function useGetCustomerArchived<TData = Awaited<ReturnType<typeof getCustomerArchived>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCustomerArchivedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerArchived>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerArchived>>,
          TError,
          Awaited<ReturnType<typeof getCustomerArchived>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerArchived<TData = Awaited<ReturnType<typeof getCustomerArchived>>, TError = ErrorType<unknown>>(
 params?: GetCustomerArchivedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerArchived>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerArchived>>,
          TError,
          Awaited<ReturnType<typeof getCustomerArchived>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerArchived<TData = Awaited<ReturnType<typeof getCustomerArchived>>, TError = ErrorType<unknown>>(
 params?: GetCustomerArchivedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerArchived>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerArchived<TData = Awaited<ReturnType<typeof getCustomerArchived>>, TError = ErrorType<unknown>>(
 params?: GetCustomerArchivedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerArchived>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerArchivedQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerInvitations = (
    params?: GetCustomerInvitationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCoachingRequestPageResponse>(
      {url: `/customer/invitations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerInvitationsQueryKey = (params?: GetCustomerInvitationsParams,) => {
    return [
    `/customer/invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerInvitations>>, TError = ErrorType<unknown>>(params?: GetCustomerInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerInvitationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerInvitations>>> = ({ signal }) => getCustomerInvitations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerInvitations>>>
export type GetCustomerInvitationsQueryError = ErrorType<unknown>


export function useGetCustomerInvitations<TData = Awaited<ReturnType<typeof getCustomerInvitations>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCustomerInvitationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerInvitations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerInvitations<TData = Awaited<ReturnType<typeof getCustomerInvitations>>, TError = ErrorType<unknown>>(
 params?: GetCustomerInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerInvitations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerInvitations<TData = Awaited<ReturnType<typeof getCustomerInvitations>>, TError = ErrorType<unknown>>(
 params?: GetCustomerInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerInvitations<TData = Awaited<ReturnType<typeof getCustomerInvitations>>, TError = ErrorType<unknown>>(
 params?: GetCustomerInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postCustomerInvitationsResendEmail = (
    trainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/customer/invitations/resend-email`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest, signal
    },
      options);
    }




export const getPostCustomerInvitationsResendEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsResendEmail>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsResendEmail>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest>}, TContext> => {

const mutationKey = ['postCustomerInvitationsResendEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerInvitationsResendEmail>>, {data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postCustomerInvitationsResendEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerInvitationsResendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerInvitationsResendEmail>>>
    export type PostCustomerInvitationsResendEmailMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest> | undefined
    export type PostCustomerInvitationsResendEmailMutationError = ErrorType<unknown>

    export const usePostCustomerInvitationsResendEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsResendEmail>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerInvitationsResendEmail>>,
        TError,
        {data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostFreshInvitationRequest>},
        TContext
      > => {
      return useMutation(getPostCustomerInvitationsResendEmailMutationOptions(options), queryClient);
    }
    export const deleteCustomerInvitationsInvitationId = (
    invitationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/customer/invitations/${invitationId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteCustomerInvitationsInvitationIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerInvitationsInvitationId>>, TError,{invitationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerInvitationsInvitationId>>, TError,{invitationId: number}, TContext> => {

const mutationKey = ['deleteCustomerInvitationsInvitationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerInvitationsInvitationId>>, {invitationId: number}> = (props) => {
          const {invitationId} = props ?? {};

          return  deleteCustomerInvitationsInvitationId(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerInvitationsInvitationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerInvitationsInvitationId>>>

    export type DeleteCustomerInvitationsInvitationIdMutationError = ErrorType<unknown>

    export const useDeleteCustomerInvitationsInvitationId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerInvitationsInvitationId>>, TError,{invitationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerInvitationsInvitationId>>,
        TError,
        {invitationId: number},
        TContext
      > => {
      return useMutation(getDeleteCustomerInvitationsInvitationIdMutationOptions(options), queryClient);
    }
    export const postCustomerInvitationsInvitationIdAccept = (
    invitationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetCustomerResponse>(
      {url: `/customer/invitations/${invitationId}/accept`, method: 'POST', signal
    },
      options);
    }




export const getPostCustomerInvitationsInvitationIdAcceptMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdAccept>>, TError,{invitationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdAccept>>, TError,{invitationId: number}, TContext> => {

const mutationKey = ['postCustomerInvitationsInvitationIdAccept'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdAccept>>, {invitationId: number}> = (props) => {
          const {invitationId} = props ?? {};

          return  postCustomerInvitationsInvitationIdAccept(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerInvitationsInvitationIdAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdAccept>>>

    export type PostCustomerInvitationsInvitationIdAcceptMutationError = ErrorType<unknown>

    export const usePostCustomerInvitationsInvitationIdAccept = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdAccept>>, TError,{invitationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdAccept>>,
        TError,
        {invitationId: number},
        TContext
      > => {
      return useMutation(getPostCustomerInvitationsInvitationIdAcceptMutationOptions(options), queryClient);
    }
    export const postCustomerInvitationsInvitationIdResendEmail = (
    invitationId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/customer/invitations/${invitationId}/resend-email`, method: 'POST', signal
    },
      options);
    }




export const getPostCustomerInvitationsInvitationIdResendEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdResendEmail>>, TError,{invitationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdResendEmail>>, TError,{invitationId: number}, TContext> => {

const mutationKey = ['postCustomerInvitationsInvitationIdResendEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdResendEmail>>, {invitationId: number}> = (props) => {
          const {invitationId} = props ?? {};

          return  postCustomerInvitationsInvitationIdResendEmail(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerInvitationsInvitationIdResendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdResendEmail>>>

    export type PostCustomerInvitationsInvitationIdResendEmailMutationError = ErrorType<unknown>

    export const usePostCustomerInvitationsInvitationIdResendEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdResendEmail>>, TError,{invitationId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerInvitationsInvitationIdResendEmail>>,
        TError,
        {invitationId: number},
        TContext
      > => {
      return useMutation(getPostCustomerInvitationsInvitationIdResendEmailMutationOptions(options), queryClient);
    }
    export const postCustomerInvite = (
    trainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetCustomerResponse>(
      {url: `/customer/invite`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest, signal
    },
      options);
    }




export const getPostCustomerInviteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvite>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvite>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest>}, TContext> => {

const mutationKey = ['postCustomerInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerInvite>>, {data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postCustomerInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerInvite>>>
    export type PostCustomerInviteMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest> | undefined
    export type PostCustomerInviteMutationError = ErrorType<unknown>

    export const usePostCustomerInvite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerInvite>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerInvite>>,
        TError,
        {data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostInviteCustomerRequest>},
        TContext
      > => {
      return useMutation(getPostCustomerInviteMutationOptions(options), queryClient);
    }
    export const getCustomerMeInvitations = (
    params?: GetCustomerMeInvitationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesMyInvitationPageResponse>(
      {url: `/customer/me/invitations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerMeInvitationsQueryKey = (params?: GetCustomerMeInvitationsParams,) => {
    return [
    `/customer/me/invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerMeInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError = ErrorType<unknown>>(params?: GetCustomerMeInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerMeInvitationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerMeInvitations>>> = ({ signal }) => getCustomerMeInvitations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerMeInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerMeInvitations>>>
export type GetCustomerMeInvitationsQueryError = ErrorType<unknown>


export function useGetCustomerMeInvitations<TData = Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCustomerMeInvitationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerMeInvitations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerMeInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerMeInvitations<TData = Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError = ErrorType<unknown>>(
 params?: GetCustomerMeInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerMeInvitations>>,
          TError,
          Awaited<ReturnType<typeof getCustomerMeInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerMeInvitations<TData = Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError = ErrorType<unknown>>(
 params?: GetCustomerMeInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerMeInvitations<TData = Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError = ErrorType<unknown>>(
 params?: GetCustomerMeInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerMeInvitations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerMeInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postCustomerMeInvitations = (
    trainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetTrainerInvitationResponse>(
      {url: `/customer/me/invitations`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest, signal
    },
      options);
    }




export const getPostCustomerMeInvitationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerMeInvitations>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerMeInvitations>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest>}, TContext> => {

const mutationKey = ['postCustomerMeInvitations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerMeInvitations>>, {data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postCustomerMeInvitations(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerMeInvitationsMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerMeInvitations>>>
    export type PostCustomerMeInvitationsMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest> | undefined
    export type PostCustomerMeInvitationsMutationError = ErrorType<unknown>

    export const usePostCustomerMeInvitations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerMeInvitations>>, TError,{data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerMeInvitations>>,
        TError,
        {data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostCoachingRequestRequest>},
        TContext
      > => {
      return useMutation(getPostCustomerMeInvitationsMutationOptions(options), queryClient);
    }
    export const getCustomerSeatUsage = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesSeatUsageResponse>(
      {url: `/customer/seat-usage`, method: 'GET', signal
    },
      options);
    }




export const getGetCustomerSeatUsageQueryKey = () => {
    return [
    `/customer/seat-usage`
    ] as const;
    }


export const getGetCustomerSeatUsageQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerSeatUsageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerSeatUsage>>> = ({ signal }) => getCustomerSeatUsage(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerSeatUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerSeatUsage>>>
export type GetCustomerSeatUsageQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetCustomerSeatUsage<TData = Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerSeatUsage>>,
          TError,
          Awaited<ReturnType<typeof getCustomerSeatUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerSeatUsage<TData = Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerSeatUsage>>,
          TError,
          Awaited<ReturnType<typeof getCustomerSeatUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerSeatUsage<TData = Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerSeatUsage<TData = Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerSeatUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerSeatUsageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetCustomerResponse>(
      {url: `/customer/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetCustomerIdQueryKey = (id: number,) => {
    return [
    `/customer/${id}`
    ] as const;
    }


export const getGetCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerId>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerId>>> = ({ signal }) => getCustomerId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerId>>>
export type GetCustomerIdQueryError = ErrorType<unknown>


export function useGetCustomerId<TData = Awaited<ReturnType<typeof getCustomerId>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerId<TData = Awaited<ReturnType<typeof getCustomerId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerId<TData = Awaited<ReturnType<typeof getCustomerId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerId<TData = Awaited<ReturnType<typeof getCustomerId>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchCustomerId = (
    id: number,
    trainWithMeModulesClientsDtosRequestsPatchCustomerRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchCustomerRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetCustomerResponse>(
      {url: `/customer/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsPatchCustomerRequest, signal
    },
      options);
    }




export const getPatchCustomerIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomerId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchCustomerRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCustomerId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchCustomerRequest>}, TContext> => {

const mutationKey = ['patchCustomerId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCustomerId>>, {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchCustomerRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCustomerId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchCustomerIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCustomerId>>>
    export type PatchCustomerIdMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsPatchCustomerRequest> | undefined
    export type PatchCustomerIdMutationError = ErrorType<unknown>

    export const usePatchCustomerId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomerId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchCustomerRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCustomerId>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchCustomerRequest>},
        TContext
      > => {
      return useMutation(getPatchCustomerIdMutationOptions(options), queryClient);
    }
    export const postCustomerIdArchive = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetCustomerResponse>(
      {url: `/customer/${id}/archive`, method: 'POST', signal
    },
      options);
    }




export const getPostCustomerIdArchiveMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdArchive>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdArchive>>, TError,{id: number}, TContext> => {

const mutationKey = ['postCustomerIdArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerIdArchive>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postCustomerIdArchive(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerIdArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerIdArchive>>>

    export type PostCustomerIdArchiveMutationError = ErrorType<unknown>

    export const usePostCustomerIdArchive = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdArchive>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerIdArchive>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostCustomerIdArchiveMutationOptions(options), queryClient);
    }
    export const getCustomerIdBody = (
    id: number,
    params?: GetCustomerIdBodyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerBodyResponse>(
      {url: `/customer/${id}/body`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdBodyQueryKey = (id: number,
    params?: GetCustomerIdBodyParams,) => {
    return [
    `/customer/${id}/body`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdBodyQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdBody>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdBodyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBody>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdBodyQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdBody>>> = ({ signal }) => getCustomerIdBody(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBody>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdBodyQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdBody>>>
export type GetCustomerIdBodyQueryError = ErrorType<unknown>


export function useGetCustomerIdBody<TData = Awaited<ReturnType<typeof getCustomerIdBody>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdBodyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBody>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdBody>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdBody>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdBody<TData = Awaited<ReturnType<typeof getCustomerIdBody>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdBodyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBody>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdBody>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdBody>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdBody<TData = Awaited<ReturnType<typeof getCustomerIdBody>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdBodyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBody>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdBody<TData = Awaited<ReturnType<typeof getCustomerIdBody>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdBodyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBody>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdBodyQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postCustomerIdBody = (
    id: number,
    trainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerBodyResponse>(
      {url: `/customer/${id}/body`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest, signal
    },
      options);
    }




export const getPostCustomerIdBodyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdBody>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdBody>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest>}, TContext> => {

const mutationKey = ['postCustomerIdBody'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerIdBody>>, {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  postCustomerIdBody(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerIdBodyMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerIdBody>>>
    export type PostCustomerIdBodyMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest> | undefined
    export type PostCustomerIdBodyMutationError = ErrorType<unknown>

    export const usePostCustomerIdBody = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdBody>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerIdBody>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostBodyMeasurementRequest>},
        TContext
      > => {
      return useMutation(getPostCustomerIdBodyMutationOptions(options), queryClient);
    }
    export const getCustomerIdBodyHistory = (
    id: number,
    params?: GetCustomerIdBodyHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerBodyHistoryResponse>(
      {url: `/customer/${id}/body/history`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdBodyHistoryQueryKey = (id: number,
    params?: GetCustomerIdBodyHistoryParams,) => {
    return [
    `/customer/${id}/body/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdBodyHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdBodyHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdBodyHistoryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdBodyHistory>>> = ({ signal }) => getCustomerIdBodyHistory(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdBodyHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdBodyHistory>>>
export type GetCustomerIdBodyHistoryQueryError = ErrorType<unknown>


export function useGetCustomerIdBodyHistory<TData = Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdBodyHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdBodyHistory>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdBodyHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdBodyHistory<TData = Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdBodyHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdBodyHistory>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdBodyHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdBodyHistory<TData = Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdBodyHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdBodyHistory<TData = Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdBodyHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdBodyHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdBodyHistoryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdCalendar = (
    id: number,
    params?: GetCustomerIdCalendarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerCalendarResponse>(
      {url: `/customer/${id}/calendar`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdCalendarQueryKey = (id: number,
    params?: GetCustomerIdCalendarParams,) => {
    return [
    `/customer/${id}/calendar`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdCalendarQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdCalendarQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdCalendar>>> = ({ signal }) => getCustomerIdCalendar(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdCalendar>>>
export type GetCustomerIdCalendarQueryError = ErrorType<unknown>


export function useGetCustomerIdCalendar<TData = Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdCalendarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdCalendar>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdCalendar<TData = Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdCalendar>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdCalendar<TData = Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdCalendar<TData = Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdCalendarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdCalendarQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdCompliance = (
    id: number,
    params?: GetCustomerIdComplianceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerComplianceResponse>(
      {url: `/customer/${id}/compliance`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdComplianceQueryKey = (id: number,
    params?: GetCustomerIdComplianceParams,) => {
    return [
    `/customer/${id}/compliance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdComplianceQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdComplianceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdComplianceQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdCompliance>>> = ({ signal }) => getCustomerIdCompliance(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdComplianceQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdCompliance>>>
export type GetCustomerIdComplianceQueryError = ErrorType<unknown>


export function useGetCustomerIdCompliance<TData = Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdComplianceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdCompliance>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdCompliance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdCompliance<TData = Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdComplianceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdCompliance>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdCompliance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdCompliance<TData = Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdComplianceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdCompliance<TData = Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdComplianceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdCompliance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdComplianceQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdConsistency = (
    id: number,
    params?: GetCustomerIdConsistencyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerConsistencyResponse>(
      {url: `/customer/${id}/consistency`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdConsistencyQueryKey = (id: number,
    params?: GetCustomerIdConsistencyParams,) => {
    return [
    `/customer/${id}/consistency`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdConsistencyQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdConsistencyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdConsistencyQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdConsistency>>> = ({ signal }) => getCustomerIdConsistency(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdConsistencyQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdConsistency>>>
export type GetCustomerIdConsistencyQueryError = ErrorType<unknown>


export function useGetCustomerIdConsistency<TData = Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdConsistencyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdConsistency>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdConsistency>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdConsistency<TData = Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdConsistencyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdConsistency>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdConsistency>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdConsistency<TData = Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdConsistencyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdConsistency<TData = Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdConsistencyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdConsistency>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdConsistencyQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdDetail = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerDetailResponse>(
      {url: `/customer/${id}/detail`, method: 'GET', signal
    },
      options);
    }




export const getGetCustomerIdDetailQueryKey = (id: number,) => {
    return [
    `/customer/${id}/detail`
    ] as const;
    }


export const getGetCustomerIdDetailQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdDetail>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdDetailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdDetail>>> = ({ signal }) => getCustomerIdDetail(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdDetail>>>
export type GetCustomerIdDetailQueryError = ErrorType<unknown>


export function useGetCustomerIdDetail<TData = Awaited<ReturnType<typeof getCustomerIdDetail>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdDetail>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdDetail<TData = Awaited<ReturnType<typeof getCustomerIdDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdDetail>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdDetail<TData = Awaited<ReturnType<typeof getCustomerIdDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdDetail<TData = Awaited<ReturnType<typeof getCustomerIdDetail>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdDetail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdDetailQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdExerciseMatrix = (
    id: number,
    params?: GetCustomerIdExerciseMatrixParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerExerciseMatrixResponse>(
      {url: `/customer/${id}/exercise-matrix`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdExerciseMatrixQueryKey = (id: number,
    params?: GetCustomerIdExerciseMatrixParams,) => {
    return [
    `/customer/${id}/exercise-matrix`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdExerciseMatrixQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdExerciseMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdExerciseMatrixQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>> = ({ signal }) => getCustomerIdExerciseMatrix(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdExerciseMatrixQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>>
export type GetCustomerIdExerciseMatrixQueryError = ErrorType<unknown>


export function useGetCustomerIdExerciseMatrix<TData = Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdExerciseMatrixParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdExerciseMatrix<TData = Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdExerciseMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdExerciseMatrix<TData = Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdExerciseMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdExerciseMatrix<TData = Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdExerciseMatrixParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseMatrix>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdExerciseMatrixQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdExerciseExerciseIdRecords = (
    id: number,
    exerciseId: number,
    params?: GetCustomerIdExerciseExerciseIdRecordsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerExerciseRecordsResponse>(
      {url: `/customer/${id}/exercise/${exerciseId}/records`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdExerciseExerciseIdRecordsQueryKey = (id: number,
    exerciseId: number,
    params?: GetCustomerIdExerciseExerciseIdRecordsParams,) => {
    return [
    `/customer/${id}/exercise/${exerciseId}/records`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdExerciseExerciseIdRecordsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError = ErrorType<unknown>>(id: number,
    exerciseId: number,
    params?: GetCustomerIdExerciseExerciseIdRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdExerciseExerciseIdRecordsQueryKey(id,exerciseId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>> = ({ signal }) => getCustomerIdExerciseExerciseIdRecords(id,exerciseId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && exerciseId !== null && exerciseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdExerciseExerciseIdRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>>
export type GetCustomerIdExerciseExerciseIdRecordsQueryError = ErrorType<unknown>


export function useGetCustomerIdExerciseExerciseIdRecords<TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number,
    params: undefined |  GetCustomerIdExerciseExerciseIdRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdExerciseExerciseIdRecords<TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number,
    params?: GetCustomerIdExerciseExerciseIdRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdExerciseExerciseIdRecords<TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number,
    params?: GetCustomerIdExerciseExerciseIdRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdExerciseExerciseIdRecords<TData = Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number,
    params?: GetCustomerIdExerciseExerciseIdRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdExerciseExerciseIdRecords>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdExerciseExerciseIdRecordsQueryOptions(id,exerciseId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdGoal = (
    id: number,
    params?: GetCustomerIdGoalParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerGoalResponse>(
      {url: `/customer/${id}/goal`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdGoalQueryKey = (id: number,
    params?: GetCustomerIdGoalParams,) => {
    return [
    `/customer/${id}/goal`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdGoalQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdGoal>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdGoalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdGoal>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdGoalQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdGoal>>> = ({ signal }) => getCustomerIdGoal(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdGoal>>>
export type GetCustomerIdGoalQueryError = ErrorType<unknown>


export function useGetCustomerIdGoal<TData = Awaited<ReturnType<typeof getCustomerIdGoal>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdGoalParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdGoal>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdGoal<TData = Awaited<ReturnType<typeof getCustomerIdGoal>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdGoalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdGoal>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdGoal<TData = Awaited<ReturnType<typeof getCustomerIdGoal>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdGoalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdGoal>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdGoal<TData = Awaited<ReturnType<typeof getCustomerIdGoal>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdGoalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdGoal>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdGoalQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postCustomerIdGoal = (
    id: number,
    trainWithMeModulesClientsDtosRequestsPostGoalRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsPostGoalRequest>,
    params?: PostCustomerIdGoalParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerGoalResponse>(
      {url: `/customer/${id}/goal`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsPostGoalRequest,
        params, signal
    },
      options);
    }




export const getPostCustomerIdGoalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdGoal>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostGoalRequest>;params?: PostCustomerIdGoalParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdGoal>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostGoalRequest>;params?: PostCustomerIdGoalParams}, TContext> => {

const mutationKey = ['postCustomerIdGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerIdGoal>>, {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostGoalRequest>;params?: PostCustomerIdGoalParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  postCustomerIdGoal(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerIdGoalMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerIdGoal>>>
    export type PostCustomerIdGoalMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsPostGoalRequest> | undefined
    export type PostCustomerIdGoalMutationError = ErrorType<unknown>

    export const usePostCustomerIdGoal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdGoal>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostGoalRequest>;params?: PostCustomerIdGoalParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerIdGoal>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPostGoalRequest>;params?: PostCustomerIdGoalParams},
        TContext
      > => {
      return useMutation(getPostCustomerIdGoalMutationOptions(options), queryClient);
    }
    export const deleteCustomerIdGoalGoalId = (
    id: number,
    goalId: number,
    params?: DeleteCustomerIdGoalGoalIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerGoalResponse>(
      {url: `/customer/${id}/goal/${goalId}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteCustomerIdGoalGoalIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerIdGoalGoalId>>, TError,{id: number;goalId: number;params?: DeleteCustomerIdGoalGoalIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerIdGoalGoalId>>, TError,{id: number;goalId: number;params?: DeleteCustomerIdGoalGoalIdParams}, TContext> => {

const mutationKey = ['deleteCustomerIdGoalGoalId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerIdGoalGoalId>>, {id: number;goalId: number;params?: DeleteCustomerIdGoalGoalIdParams}> = (props) => {
          const {id,goalId,params} = props ?? {};

          return  deleteCustomerIdGoalGoalId(id,goalId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerIdGoalGoalIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerIdGoalGoalId>>>

    export type DeleteCustomerIdGoalGoalIdMutationError = ErrorType<unknown>

    export const useDeleteCustomerIdGoalGoalId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerIdGoalGoalId>>, TError,{id: number;goalId: number;params?: DeleteCustomerIdGoalGoalIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerIdGoalGoalId>>,
        TError,
        {id: number;goalId: number;params?: DeleteCustomerIdGoalGoalIdParams},
        TContext
      > => {
      return useMutation(getDeleteCustomerIdGoalGoalIdMutationOptions(options), queryClient);
    }
    export const patchCustomerIdGoalGoalId = (
    id: number,
    goalId: number,
    trainWithMeModulesClientsDtosRequestsPatchGoalRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchGoalRequest>,
    params?: PatchCustomerIdGoalGoalIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerGoalResponse>(
      {url: `/customer/${id}/goal/${goalId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsPatchGoalRequest,
        params, signal
    },
      options);
    }




export const getPatchCustomerIdGoalGoalIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomerIdGoalGoalId>>, TError,{id: number;goalId: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchGoalRequest>;params?: PatchCustomerIdGoalGoalIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCustomerIdGoalGoalId>>, TError,{id: number;goalId: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchGoalRequest>;params?: PatchCustomerIdGoalGoalIdParams}, TContext> => {

const mutationKey = ['patchCustomerIdGoalGoalId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCustomerIdGoalGoalId>>, {id: number;goalId: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchGoalRequest>;params?: PatchCustomerIdGoalGoalIdParams}> = (props) => {
          const {id,goalId,data,params} = props ?? {};

          return  patchCustomerIdGoalGoalId(id,goalId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchCustomerIdGoalGoalIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCustomerIdGoalGoalId>>>
    export type PatchCustomerIdGoalGoalIdMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsPatchGoalRequest> | undefined
    export type PatchCustomerIdGoalGoalIdMutationError = ErrorType<unknown>

    export const usePatchCustomerIdGoalGoalId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomerIdGoalGoalId>>, TError,{id: number;goalId: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchGoalRequest>;params?: PatchCustomerIdGoalGoalIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCustomerIdGoalGoalId>>,
        TError,
        {id: number;goalId: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsPatchGoalRequest>;params?: PatchCustomerIdGoalGoalIdParams},
        TContext
      > => {
      return useMutation(getPatchCustomerIdGoalGoalIdMutationOptions(options), queryClient);
    }
    export const postCustomerIdGoalGoalIdComplete = (
    id: number,
    goalId: number,
    params?: PostCustomerIdGoalGoalIdCompleteParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerGoalResponse>(
      {url: `/customer/${id}/goal/${goalId}/complete`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostCustomerIdGoalGoalIdCompleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdGoalGoalIdComplete>>, TError,{id: number;goalId: number;params?: PostCustomerIdGoalGoalIdCompleteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdGoalGoalIdComplete>>, TError,{id: number;goalId: number;params?: PostCustomerIdGoalGoalIdCompleteParams}, TContext> => {

const mutationKey = ['postCustomerIdGoalGoalIdComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerIdGoalGoalIdComplete>>, {id: number;goalId: number;params?: PostCustomerIdGoalGoalIdCompleteParams}> = (props) => {
          const {id,goalId,params} = props ?? {};

          return  postCustomerIdGoalGoalIdComplete(id,goalId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerIdGoalGoalIdCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerIdGoalGoalIdComplete>>>

    export type PostCustomerIdGoalGoalIdCompleteMutationError = ErrorType<unknown>

    export const usePostCustomerIdGoalGoalIdComplete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdGoalGoalIdComplete>>, TError,{id: number;goalId: number;params?: PostCustomerIdGoalGoalIdCompleteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerIdGoalGoalIdComplete>>,
        TError,
        {id: number;goalId: number;params?: PostCustomerIdGoalGoalIdCompleteParams},
        TContext
      > => {
      return useMutation(getPostCustomerIdGoalGoalIdCompleteMutationOptions(options), queryClient);
    }
    export const getCustomerIdHistory = (
    id: number,
    params?: GetCustomerIdHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerHistoryResponse>(
      {url: `/customer/${id}/history`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdHistoryQueryKey = (id: number,
    params?: GetCustomerIdHistoryParams,) => {
    return [
    `/customer/${id}/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdHistory>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdHistoryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdHistory>>> = ({ signal }) => getCustomerIdHistory(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdHistory>>>
export type GetCustomerIdHistoryQueryError = ErrorType<unknown>


export function useGetCustomerIdHistory<TData = Awaited<ReturnType<typeof getCustomerIdHistory>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdHistory<TData = Awaited<ReturnType<typeof getCustomerIdHistory>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdHistory>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdHistory<TData = Awaited<ReturnType<typeof getCustomerIdHistory>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdHistory<TData = Awaited<ReturnType<typeof getCustomerIdHistory>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdHistoryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postCustomerIdInvite = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerInvitationResponse>(
      {url: `/customer/${id}/invite`, method: 'POST', signal
    },
      options);
    }




export const getPostCustomerIdInviteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdInvite>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdInvite>>, TError,{id: number}, TContext> => {

const mutationKey = ['postCustomerIdInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerIdInvite>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postCustomerIdInvite(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerIdInviteMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerIdInvite>>>

    export type PostCustomerIdInviteMutationError = ErrorType<unknown>

    export const usePostCustomerIdInvite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerIdInvite>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerIdInvite>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostCustomerIdInviteMutationOptions(options), queryClient);
    }
    export const getCustomerIdLastSession = (
    id: number,
    params?: GetCustomerIdLastSessionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerLastSessionResponse>(
      {url: `/customer/${id}/last-session`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdLastSessionQueryKey = (id: number,
    params?: GetCustomerIdLastSessionParams,) => {
    return [
    `/customer/${id}/last-session`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdLastSessionQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdLastSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdLastSessionQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdLastSession>>> = ({ signal }) => getCustomerIdLastSession(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdLastSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdLastSession>>>
export type GetCustomerIdLastSessionQueryError = ErrorType<unknown>


export function useGetCustomerIdLastSession<TData = Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdLastSessionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdLastSession>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdLastSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdLastSession<TData = Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdLastSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdLastSession>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdLastSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdLastSession<TData = Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdLastSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdLastSession<TData = Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdLastSessionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdLastSession>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdLastSessionQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdMuscleVolume = (
    id: number,
    params?: GetCustomerIdMuscleVolumeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerMuscleVolumeResponse>(
      {url: `/customer/${id}/muscle-volume`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdMuscleVolumeQueryKey = (id: number,
    params?: GetCustomerIdMuscleVolumeParams,) => {
    return [
    `/customer/${id}/muscle-volume`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdMuscleVolumeQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdMuscleVolumeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdMuscleVolumeQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>> = ({ signal }) => getCustomerIdMuscleVolume(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdMuscleVolumeQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>>
export type GetCustomerIdMuscleVolumeQueryError = ErrorType<unknown>


export function useGetCustomerIdMuscleVolume<TData = Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdMuscleVolumeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdMuscleVolume<TData = Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdMuscleVolumeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdMuscleVolume<TData = Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdMuscleVolumeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdMuscleVolume<TData = Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdMuscleVolumeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdMuscleVolume>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdMuscleVolumeQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteCustomerIdNote = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/customer/${id}/note`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteCustomerIdNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerIdNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerIdNote>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCustomerIdNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerIdNote>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomerIdNote(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerIdNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerIdNote>>>

    export type DeleteCustomerIdNoteMutationError = ErrorType<unknown>

    export const useDeleteCustomerIdNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerIdNote>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerIdNote>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCustomerIdNoteMutationOptions(options), queryClient);
    }
    export const getCustomerIdNote = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerNoteResponse>(
      {url: `/customer/${id}/note`, method: 'GET', signal
    },
      options);
    }




export const getGetCustomerIdNoteQueryKey = (id: number,) => {
    return [
    `/customer/${id}/note`
    ] as const;
    }


export const getGetCustomerIdNoteQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdNote>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdNote>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdNoteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdNote>>> = ({ signal }) => getCustomerIdNote(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdNote>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdNoteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdNote>>>
export type GetCustomerIdNoteQueryError = ErrorType<unknown>


export function useGetCustomerIdNote<TData = Awaited<ReturnType<typeof getCustomerIdNote>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdNote>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdNote>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdNote>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdNote<TData = Awaited<ReturnType<typeof getCustomerIdNote>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdNote>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdNote>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdNote>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdNote<TData = Awaited<ReturnType<typeof getCustomerIdNote>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdNote>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdNote<TData = Awaited<ReturnType<typeof getCustomerIdNote>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdNote>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdNoteQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putCustomerIdNote = (
    id: number,
    trainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest?: BodyType<TrainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerNoteResponse>(
      {url: `/customer/${id}/note`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest, signal
    },
      options);
    }




export const getPutCustomerIdNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCustomerIdNote>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putCustomerIdNote>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest>}, TContext> => {

const mutationKey = ['putCustomerIdNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCustomerIdNote>>, {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  putCustomerIdNote(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutCustomerIdNoteMutationResult = NonNullable<Awaited<ReturnType<typeof putCustomerIdNote>>>
    export type PutCustomerIdNoteMutationBody = BodyType<TrainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest> | undefined
    export type PutCustomerIdNoteMutationError = ErrorType<unknown>

    export const usePutCustomerIdNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCustomerIdNote>>, TError,{id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCustomerIdNote>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesClientsDtosRequestsUpsertCustomerNoteRequest>},
        TContext
      > => {
      return useMutation(getPutCustomerIdNoteMutationOptions(options), queryClient);
    }
    export const getCustomerIdPersonalRecords = (
    id: number,
    params?: GetCustomerIdPersonalRecordsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerPersonalRecordsResponse>(
      {url: `/customer/${id}/personal-records`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdPersonalRecordsQueryKey = (id: number,
    params?: GetCustomerIdPersonalRecordsParams,) => {
    return [
    `/customer/${id}/personal-records`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdPersonalRecordsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdPersonalRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdPersonalRecordsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>> = ({ signal }) => getCustomerIdPersonalRecords(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdPersonalRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>>
export type GetCustomerIdPersonalRecordsQueryError = ErrorType<unknown>


export function useGetCustomerIdPersonalRecords<TData = Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdPersonalRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdPersonalRecords<TData = Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdPersonalRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdPersonalRecords<TData = Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdPersonalRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdPersonalRecords<TData = Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdPersonalRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdPersonalRecords>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdPersonalRecordsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdProgressSummary = (
    id: number,
    params?: GetCustomerIdProgressSummaryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerProgressSummaryResponse>(
      {url: `/customer/${id}/progress-summary`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdProgressSummaryQueryKey = (id: number,
    params?: GetCustomerIdProgressSummaryParams,) => {
    return [
    `/customer/${id}/progress-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdProgressSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdProgressSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdProgressSummaryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdProgressSummary>>> = ({ signal }) => getCustomerIdProgressSummary(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdProgressSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdProgressSummary>>>
export type GetCustomerIdProgressSummaryQueryError = ErrorType<unknown>


export function useGetCustomerIdProgressSummary<TData = Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdProgressSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdProgressSummary>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdProgressSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdProgressSummary<TData = Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdProgressSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdProgressSummary>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdProgressSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdProgressSummary<TData = Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdProgressSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdProgressSummary<TData = Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdProgressSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdProgressSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdProgressSummaryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdRecentSessions = (
    id: number,
    params?: GetCustomerIdRecentSessionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerRecentSessionsResponse>(
      {url: `/customer/${id}/recent-sessions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdRecentSessionsQueryKey = (id: number,
    params?: GetCustomerIdRecentSessionsParams,) => {
    return [
    `/customer/${id}/recent-sessions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdRecentSessionsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdRecentSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdRecentSessionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdRecentSessions>>> = ({ signal }) => getCustomerIdRecentSessions(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdRecentSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdRecentSessions>>>
export type GetCustomerIdRecentSessionsQueryError = ErrorType<unknown>


export function useGetCustomerIdRecentSessions<TData = Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdRecentSessionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdRecentSessions>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdRecentSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdRecentSessions<TData = Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdRecentSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdRecentSessions>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdRecentSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdRecentSessions<TData = Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdRecentSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdRecentSessions<TData = Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdRecentSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdRecentSessions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdRecentSessionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdTrainedExercises = (
    id: number,
    params?: GetCustomerIdTrainedExercisesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerTrainedExercisesResponse>(
      {url: `/customer/${id}/trained-exercises`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdTrainedExercisesQueryKey = (id: number,
    params?: GetCustomerIdTrainedExercisesParams,) => {
    return [
    `/customer/${id}/trained-exercises`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdTrainedExercisesQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdTrainedExercisesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdTrainedExercisesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>> = ({ signal }) => getCustomerIdTrainedExercises(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdTrainedExercisesQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>>
export type GetCustomerIdTrainedExercisesQueryError = ErrorType<unknown>


export function useGetCustomerIdTrainedExercises<TData = Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdTrainedExercisesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdTrainedExercises<TData = Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdTrainedExercisesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdTrainedExercises<TData = Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdTrainedExercisesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdTrainedExercises<TData = Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdTrainedExercisesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainedExercises>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdTrainedExercisesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCustomerIdTrainingTrends = (
    id: number,
    params?: GetCustomerIdTrainingTrendsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesCustomerTrainingTrendsResponse>(
      {url: `/customer/${id}/training-trends`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCustomerIdTrainingTrendsQueryKey = (id: number,
    params?: GetCustomerIdTrainingTrendsParams,) => {
    return [
    `/customer/${id}/training-trends`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerIdTrainingTrendsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError = ErrorType<unknown>>(id: number,
    params?: GetCustomerIdTrainingTrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdTrainingTrendsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>> = ({ signal }) => getCustomerIdTrainingTrends(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdTrainingTrendsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>>
export type GetCustomerIdTrainingTrendsQueryError = ErrorType<unknown>


export function useGetCustomerIdTrainingTrends<TData = Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetCustomerIdTrainingTrendsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdTrainingTrends<TData = Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdTrainingTrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>,
          TError,
          Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerIdTrainingTrends<TData = Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdTrainingTrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCustomerIdTrainingTrends<TData = Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetCustomerIdTrainingTrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerIdTrainingTrends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdTrainingTrendsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






